import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IAiResult, AiResult } from "@/models/ai-result.entity";

export const AiResultDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IAiResult> {
  protected mapEntity(entity: IAiResult): IAiResult {
    return new AiResult(entity);
  }

  getIdentifier(entity: IAiResult): string {
    return entity.id;
  }

  mapsConfig = {};
})();
